import LoginPage from "@/features/auth/pages/login";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(auth)/__auth/login")({
  component: AuthRoute,
});

function AuthRoute() {
  return <LoginPage />;
}
